module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }